"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class IdentityServiceImpl {
    constructor(coachClient) {
        this.getId = async () => (await this.coachClient.getPersonalInformation()).id;
        this.getDisplayName = async () => (await this.coachClient.getPersonalInformation()).name;
        this.coachClient = coachClient;
    }
}
exports.default = IdentityServiceImpl;
//# sourceMappingURL=IdentityService.js.map